/*
 * Brand name guardrail.
 *
 * Two passes per text node:
 *   1. Any case of "Deesse Pro" / "Déesse Pro" / "DEESSE PRO" → wrapped
 *      <span class="brand-name">Déesse PRO</span>
 *   2. Standalone "Deesse" / "DEESSE" (missing the accent) → wrapped
 *      <span class="brand-name">Déesse</span>
 *
 * The wrapper class disables text-transform / font-variant-caps so the casing
 * survives any CSS in the surrounding context.
 *
 * Runs on DOMContentLoaded and watches the document with a MutationObserver
 * so dynamically injected content (reviews, AI advisor, quiz, infinite-scroll
 * article cards, third-party widgets) is also corrected.
 */
(function () {
  'use strict';

  // Two passes. Order matters: the "+ Pro" pattern runs first so a phrase
  // like "Deesse Pro" is collapsed into a single span before the standalone
  // pattern would otherwise grab just the "Deesse" half.
  var PATTERNS = [
    { re: /d[eé]esse\s+pro/gi, replacement: 'Déesse PRO' },
    { re: /d[eé]esse/gi,       replacement: 'Déesse' }
  ];

  var SKIP_TAGS = {
    SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, NOSCRIPT: 1,
    CODE: 1, PRE: 1, KBD: 1, SAMP: 1, TITLE: 1
  };

  function isInsideBrandSpan(node) {
    var p = node.parentNode;
    while (p && p.nodeType === 1) {
      if (p.classList && p.classList.contains('brand-name')) return true;
      p = p.parentNode;
    }
    return false;
  }

  function shouldSkip(node) {
    var p = node.parentNode;
    if (!p || p.nodeType !== 1) return true;
    if (SKIP_TAGS[p.tagName]) return true;
    if (p.isContentEditable) return true;
    return false;
  }

  function makeBrandSpan(text) {
    var span = document.createElement('span');
    span.className = 'brand-name';
    span.setAttribute('translate', 'no');
    span.textContent = text;
    return span;
  }

  // Build a unified match list across all patterns, then materialise into a
  // fragment. Matches are non-overlapping because the longer "+ Pro" pattern
  // is applied first and its matched ranges are excluded from the second pass.
  function findMatches(text) {
    var matches = [];
    for (var i = 0; i < PATTERNS.length; i++) {
      var p = PATTERNS[i];
      p.re.lastIndex = 0;
      var m;
      while ((m = p.re.exec(text)) !== null) {
        var start = m.index;
        var end = start + m[0].length;
        // Skip if this range overlaps a previously claimed match.
        var overlaps = false;
        for (var j = 0; j < matches.length; j++) {
          if (start < matches[j].end && end > matches[j].start) {
            overlaps = true;
            break;
          }
        }
        if (!overlaps) {
          matches.push({ start: start, end: end, text: p.replacement });
        }
      }
    }
    matches.sort(function (a, b) { return a.start - b.start; });
    return matches;
  }

  function replaceInTextNode(textNode) {
    var text = textNode.nodeValue;
    if (!text || text.length < 6) return;
    if (shouldSkip(textNode) || isInsideBrandSpan(textNode)) return;

    var matches = findMatches(text);
    if (matches.length === 0) return;

    var frag = document.createDocumentFragment();
    var cursor = 0;
    for (var i = 0; i < matches.length; i++) {
      var m = matches[i];
      if (m.start > cursor) {
        frag.appendChild(document.createTextNode(text.slice(cursor, m.start)));
      }
      frag.appendChild(makeBrandSpan(m.text));
      cursor = m.end;
    }
    if (cursor < text.length) {
      frag.appendChild(document.createTextNode(text.slice(cursor)));
    }
    textNode.parentNode.replaceChild(frag, textNode);
  }

  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) {
      replaceInTextNode(root);
      return;
    }
    if (root.nodeType !== 1 && root.nodeType !== 9 && root.nodeType !== 11) return;
    if (root.nodeType === 1 && SKIP_TAGS[root.tagName]) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (shouldSkip(n)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    var current;
    while ((current = walker.nextNode())) nodes.push(current);
    for (var i = 0; i < nodes.length; i++) replaceInTextNode(nodes[i]);
  }

  function start() {
    walk(document.body);
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'childList') {
          for (var j = 0; j < m.addedNodes.length; j++) walk(m.addedNodes[j]);
        } else if (m.type === 'characterData') {
          replaceInTextNode(m.target);
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
